import type { RawApiResponse } from "@/lib/apiClient";

type SessionUser = { name?: string | null; email: string; image?: string | null };

function imageSource(value: unknown): string | null {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === "https:" || url.protocol === "http:" ? url.href : null;
  } catch {
    return null;
  }
}

export function profileIdentity(user: SessionUser, response?: RawApiResponse) {
  const body = response?.status === 200 ? response.body : null;
  const profile = body && typeof body === "object" && !Array.isArray(body)
    ? body as Record<string, unknown> : null;
  const profileName = [profile?.firstName, profile?.lastName]
    .filter((part): part is string => typeof part === "string" && Boolean(part.trim()))
    .map((part) => part.trim()).join(" ");
  return {
    name: profile ? profileName || user.email : user.name?.trim() || user.email,
    // A successfully read empty avatar means the user removed it. Never restore
    // a stale provider photo over the profile's authoritative value.
    imageUrl: imageSource(profile ? profile.imageUrl : user.image),
  };
}
